import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/device_firmware_versions?include=cashRegister,currentFirmware`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/device_firmware_versions/${id}?include=cashRegister,cashRegister.device,currentFirmware`, options)
        .then(response => {
            let deviceFirmwareVersion = jsona.deserialize(response.data);
            delete deviceFirmwareVersion.links;
            return deviceFirmwareVersion;
        });
}

function add(deviceFirmwareVersion) {
    const payload = jsona.serialize({
        stuff: deviceFirmwareVersion,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device_firmware_versions`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function multipleAdd(deviceFirmwareVersion) {
    // const payload = jsona.serialize({
    //     stuff: deviceFirmwareVersion,
    //     includeNames: null
    // });
    const payload = deviceFirmwareVersion;

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device-firmware-versions/multiple-add`, payload, options)
        .then(response => {
            return response.data;
        });
}

function update(deviceFirmwareVersion) {
    const payload = jsona.serialize({
        stuff: deviceFirmwareVersion,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/device_firmware_versions/${deviceFirmwareVersion.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/device_firmware_versions/${id}`, options);
}

export default {
    list,
    get,
    add,
    multipleAdd,
    update,
    destroy
};